import React, { FC } from 'react'
import { SoldOutBanner } from '@moonpig/web-shared-products'
import { Box, PrimaryButton } from '@moonpig/launchpad-components'
import { useStore } from '@moonpig/web-core-stores'
import {
  BreadcrumbsModule,
  ColumnModule,
  GiftImageCarouselModule,
  ListModule,
  OfferBannerModule,
  ProductTitleModule,
} from '../../modules'
import { SoldOutWrapper } from '../SoldOutWrapper'
import { useProductContext } from '../../contexts/product'
import { useFindLocaleText } from '../../text-localisation'

const ShopOtherDigitalGifts = () => {
  const {
    store: { id: storeId },
  } = useStore()

  const [{ product }] = useProductContext()
  const localise = useFindLocaleText()

  return (
    <PrimaryButton
      width={1}
      href={`/${storeId}/search?d=${product.category.department}`}
    >
      {localise('find.digital_gift_redirect_cta', product.category.department)}
    </PrimaryButton>
  )
}

export const DigitalGiftTopOutOfStock: FC = () => (
  <>
    <OfferBannerModule width={1} />
    <BreadcrumbsModule withContainer />
    <ColumnModule>
      <SoldOutWrapper>
        <GiftImageCarouselModule
          flex={{ xs: 'inherit', md: 1 }}
          width={1}
          px={{ xs: 8, md: 0 }}
        />
      </SoldOutWrapper>
      <ListModule>
        <ProductTitleModule px={{ xs: 8, md: 0 }} width={1} />
        <Box width={1} my={8}>
          <SoldOutBanner />
        </Box>
        <ShopOtherDigitalGifts />
      </ListModule>
    </ColumnModule>
  </>
)
